<div class="list-container">
  <div class="events-area">
    @if (invitationsPage) {
      @for (invitation of invitations; track invitation.id) {
        <app-collaborator-invitation-card
          [invitation]="invitation"
          [isLoading]="isLoading"
          (acceptClick)="handleAcceptClick($event)" />
      } @empty {
        <p>Atualmente você não possui convites</p>
      }
    } @else {
      <p-skeleton height="250px" />
      <p-skeleton height="250px" />
      <p-skeleton height="250px" />
    }
  </div>
  <div class="actions-area">
    @if (invitationsPage && invitationsPage.meta) {
      <app-button
        (btnClick)="loadMoreInvitations()"
        styleType="clean"
        [disabled]="invitationsPage.meta.current_page >= invitationsPage.meta.total_pages">
        <i class="pi pi-plus"></i>
        Carregar mais
      </app-button>
    }
  </div>
</div>
